import { ApiResponse, ProductAttributePayload, IProductAttributes, ProductSlug, ProductChildAttributes, ProductAttributesDetails, ProductAttributes, ProductDefaultPrice, ProductVoucherPayload, VoucherResponse } from "../../../types";
import {  CheckAuthResponse, AuthError } from "../../../types/login.types";
import { getRequest, getRequestWithAuth, getRequestWithParamsAndQuery, getRequestWithQuery, postRequest, postRequestWithAuth, Tparams } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);
export interface Product{

    productBasedOnAttribute(data:ProductAttributePayload, param:Tparams):Promise<ApiResponse<IProductAttributes> >;
    productPriceAndVoucher(attribute:ProductVoucherPayload, catId:number, cityId:number|string, sessionCode:string):Promise<ApiResponse<VoucherResponse>>

    getProductDefaultPrice(catId:number):Promise<ApiResponse<ProductDefaultPrice>>
    getVoucher():Promise<ApiResponse<CheckAuthResponse, AuthError>>
    getCategoryBySlug(slug:string):Promise<ApiResponse<ProductAttributesDetails>>
    getCategoryAttributes(productId:number):Promise<ApiResponse<ProductChildAttributes[]>>;
    getCategoryDetails(productId:number, cityId?:number):Promise<ApiResponse<ProductAttributesDetails>>
    getProductAttribute(cat_id:number):Promise<ApiResponse<ProductAttributes>>
    getProductServiceabilityCheck(param:Tparams): Promise<any>
}

const product: Product = {
    productBasedOnAttribute(data, params ) {
        return postRequest(api.PRODUCT_BASED_ON_ATTRIBUTE, data, params,)
    },
  
    getProductDefaultPrice(cat_id) {
      return getRequest(api.PRODUCT_DEFAULT_PRICE, cat_id)
    },

    productPriceAndVoucher(attributesPayload, catId, cityId, sessionCode) {
      const query = {
        city:cityId,
        session_code:sessionCode

      }
      return postRequestWithAuth(api.PRODUCT_VOUCHER_AND_PRICE, attributesPayload, catId, query)
    },
    
  getVoucher() {
      return getRequestWithAuth(api.CHECK_AUTH)
  },

  getCategoryBySlug(slug){
    
    return getRequest(api.PRODUCT_SLUG, slug)
  },


  getCategoryAttributes(productId) {
      return getRequest(api.PRODUCT_CHILD_ATTRIBUTES, productId)
  },

  getCategoryDetails(productId, cityId) {
 
      return cityId 
      ? getRequestWithParamsAndQuery(api.PRODUCT_CATEGORY_DETAILS, productId, {query:cityId} )
      : getRequest(api.PRODUCT_CATEGORY_DETAILS, productId)
  },
  getProductAttribute(catId){
    return getRequest(api.PRODUCT_ATTRIBUTE, catId)
  },

  getProductServiceabilityCheck(parms) {
    return getRequestWithAuth(api.PRODUCT_SERVICIABILITY_CHECk, parms)
  },


}

export default product

